import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import ContractorType from '../../types/api/contractor-type'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'

export const contractorsTypesApi = createApi({
    reducerPath: 'contractorsTypesApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['ContractorsTypes'],
    endpoints: builder => ({
        getContractorsTypes: builder.query<Strapi<ContractorType>, EndpointQueryParameters | void>({
            query: getQuery('/contractors-types'),
            providesTags: ['ContractorsTypes'],
        }),
    }),
})

export const { useGetContractorsTypesQuery } = contractorsTypesApi
